import { render, staticRenderFns } from "./StudentElective.vue?vue&type=template&id=f44ed646"
import script from "./StudentElective.vue?vue&type=script&lang=js"
export * from "./StudentElective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports